import { CreateUserDetailFormSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useCreateUserDetailSchema = (
  isMinor: boolean,
  phoneNumber: string,
  currentLang: string
) => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateUserDetailFormSchema(
    {
      RequiredMessage: t('Validate_Required'),
      MailMessage: t('Validate_Mail'),
      PhoneNumberMessage: t('Validate_PhoneNumber'),
      KanaMessage: t('Validate_Kana'),
      PasswordConfirmationMessage: t('Validate_PasswordConfirmation'),
      SpecialCharacterMessage: t('Validate_SpecialCharacter'),
      UppercaseMessage: t('Validate_Uppercase'),
      LowercaseMessage: t('Validate_Lowercase'),
      ConsentRequiredMessage: t('Validate_ConsentRequired'),
      MinLengthMessage: (min: number) => t('Validate_MinLength', { min }),
      MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
      LengthMessage: (length: number) => t('Validate_Length', { length }),
      FullWidthMessage: t('Validate_FullWidth'),
      NoFullWidthMessage: t('Validate_NoFullWidth'),
      PasswordNumericMessage: t('Validate_Password_Numeric'),
    },
    isMinor,
    phoneNumber,
    currentLang
  );
  return schema;
};
